import { Component } from '@angular/core';

@Component({
  selector: 'app-mock-up',
  templateUrl: './mock-up.component.html',
  styleUrl: './mock-up.component.css',
  standalone: false
})
export class MockUpComponent {

}
